<script>
    import { selectedGroup } from '../../store';
    import { Spinner } from 'sveltestrap';    
    import http from '../../api/http.js';
    export let computerId;
    let operatingSystem;

    $: {   
      computerId;
      loadOperatingSystem()
    }

    async function loadOperatingSystem(){
        const res = await http.get(`${window.apiBaseUrl}/deploy/dashboard/computers/operatingsystem/${computerId}/${$selectedGroup}`);

        if(res.status == 200){
            operatingSystem = await res.json();
        }
    }
</script>

{#await loadOperatingSystem()}
    <Spinner color="primary" type="border"></Spinner>
{:then}
<div id="operating-system-context">
    <div class="row">
        <div class="col-sm">
            <div>
                <label for="operatingSystem-version">Version:</label>
                <span id="operatingSystem-version">{operatingSystem.version}</span>
            </div>
            <div>
                <label for="country-code">Country Code:</label>
                <span id="country-code">{operatingSystem.countryCode}</span>
            </div>
            <div>
                <label for="country-code">Current Timeszone:</label>
                <span id="country-code">{operatingSystem.currentTimezone}</span>
            </div>
        </div>
        <div class="col-sm">
            <div>
                <label for="local-datetime">Local Date Time:</label>
                <span id="local-datetime">{operatingSystem.localDateTime}</span>
            </div>
            <div>
                <label for="install-date">Install Date:</label>
                <span id="install-date">{operatingSystem.installDate}</span>
            </div>
            <div>
                <label for="last-bootup">Last Bootup Time:</label>
                <span id="last-bootup">{operatingSystem.lastBootUpTime}</span>
            </div>
        </div>
        <div class="col-sm">
            <div>
                <label for="product-type">Product Type:</label>
                <span id="product-type">{operatingSystem.productType}</span>
            </div>
            <div>
                <label for="registered-user">Registered User:</label>
                <span id="product-type">{operatingSystem.registeredUser}</span>
            </div>
            <div>
                <label for="serial">Serial:</label>
                <span id="serial">{operatingSystem.serial}</span>
            </div>  
        </div>
    </div>
</div>
{/await}

<style>
    label{
        font-weight: 600;
    }
</style>